import { useMemo } from 'react';
import { FilterSelectedValue } from '../../../hooks/filters/interfaces/filter-selected-value.interface';
import { useAppSetSelectedValue } from '../../../hooks/filters/use-app-filter-selected-value.hook';
import {
  useAppSimpleFilterSelectedValue,
  useFilterSelectionMemo,
} from './common.hook';
import { FILTER_NAMES } from './filter-names.constants';
// TODO: find a way to reuse same hook, rather than having so many, by passing a filter list.

export const useFilterCompactViewSelection = () => {
  const compactViewCategory = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.COMPACT_VIEW_CATEGORY,
  );

  const compactViewBrand = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.COMPACT_VIEW_BRAND,
  );

  const compactViewSubBrand = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.COMPACT_VIEW_SUBBRAND,
  );

  const compactViewSizeGroup = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.COMPACT_VIEW_SIZEGROUP,
  );

  const compactViewPpg = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.COMPACT_VIEW_PPG,
  );
  // const filterMemo = useMemo(() =>
  //     [
  //         compactViewCategory,
  //         compactViewBrand,
  //         compactViewSubBrand,
  //         compactViewSizeGroup,
  //         compactViewPpg,
  //     ],
  //     [
  //         compactViewCategory,
  //         compactViewBrand,
  //         compactViewSubBrand,
  //         compactViewSizeGroup,
  //         compactViewPpg,
  //     ],
  // )
  const filterSelection = useFilterSelectionMemo(
    compactViewCategory,
    compactViewBrand,
    compactViewSubBrand,
    compactViewSizeGroup,
    compactViewPpg,
  );
  return filterSelection;
};

export const useSetFilterCompactViewSelection = () => {
  const category = useAppSetSelectedValue(FILTER_NAMES.COMPACT_VIEW_CATEGORY);
  const brand = useAppSetSelectedValue(FILTER_NAMES.COMPACT_VIEW_BRAND);
  const subBrand = useAppSetSelectedValue(FILTER_NAMES.COMPACT_VIEW_SUBBRAND);
  const sizeGroup = useAppSetSelectedValue(FILTER_NAMES.COMPACT_VIEW_SIZEGROUP);
  const ppg = useAppSetSelectedValue(FILTER_NAMES.COMPACT_VIEW_PPG);
  const filterMemo = useMemo(
    (): Record<
      string,
      (selectedValue: FilterSelectedValue) => Promise<FilterSelectedValue>
    > => ({
      [FILTER_NAMES.COMPACT_VIEW_CATEGORY]: category,
      [FILTER_NAMES.COMPACT_VIEW_BRAND]: brand,
      [FILTER_NAMES.COMPACT_VIEW_SUBBRAND]: subBrand,
      [FILTER_NAMES.COMPACT_VIEW_SIZEGROUP]: sizeGroup,
      [FILTER_NAMES.COMPACT_VIEW_PPG]: ppg,
    }),
    [category, brand, subBrand, sizeGroup, ppg],
  );
  //const filterSelection = useSetValueFilterMemo(filterMemo)
  return filterMemo;
};

export const useFilterCoeficcientSelection = () => {
  const coefficientSelector = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.COEFFICIENTSELECTOR,
  );
  // const filterMemo = useMemo(() =>
  //     [coefficientSelector],
  //     [coefficientSelector],
  // )
  const filterSelection = useFilterSelectionMemo(coefficientSelector);
  return filterSelection;
};
export const useFilterVariableSelection = () => {
  const variable = useAppSimpleFilterSelectedValue(FILTER_NAMES.VARIABLE);
  // const filterMemo = useMemo(() =>
  //     [variable],
  //     [variable],
  // )
  const filterSelection = useFilterSelectionMemo(variable);
  return filterSelection;
};

export const useFilterProductHierSelection = () => {
  const prodHier = useAppSimpleFilterSelectedValue(FILTER_NAMES.PRODUCTHIER);

  // const filterMemo = useMemo(() =>
  //     [prodHier],
  //     [prodHier],
  // )
  const filterSelection = useFilterSelectionMemo(prodHier);
  return filterSelection;
};

export const useFilterVariableGroupSelection = () => {
  const variableGroup = useAppSimpleFilterSelectedValue(
    FILTER_NAMES.VARIABLEGROUP,
  );

  // const filterMemo = useMemo(() =>
  //     [variableGroup],
  //     [variableGroup],
  // )
  const filterSelection = useFilterSelectionMemo(variableGroup);
  return filterSelection;
};

export const useFilterMemoSelection = (filterId: string) => {
  const filterValue = useAppSimpleFilterSelectedValue(filterId);

  // const filterMemo = useMemo(() =>
  //     [filterValue],
  //     [filterValue],
  // )
  const filterSelection = useFilterSelectionMemo(filterValue);
  return filterSelection;
};
